/* eslint-disable */

import React, { useMemo, useState, useEffect } from "react";
import Table from "components/Table";
import api from "api";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useLoading, handleLoading } from "context/LoadingContext";
import { LockTypeEnum } from "dictionary/LockType/LockType";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function LockedAndUnlockedLand() {
  const [, loadingDispatch] = useLoading();
  const [dataTable, setDataTable] = useState([]);
  const [loadingStates, setLoadingStates] = useState({});

  const { register, watch } = useForm();
  const watchedData = watch();

  const headers = useMemo(
    () => [
      { accessorKey: "dlsKey", header: "مفتاح القطعة", width: "20%" },
      { accessorKey: "sectorCode", header: "رقم القطعة", width: "20%" },
      { accessorKey: "parcelCode", header: "الحي", width: "20%" },
      { accessorKey: "hodCode", header: "الحوض", width: "20%" },
      { accessorKey: "vilCode", header: "القرية", width: "20%" },
      {
        accessorKey: "locked",
        header: "مغلق",
        width: "20%",
        cell: (param) => {
          const data = param.cell.row.original;
          const isLoading = loadingStates[data.dlsKey];
          return (
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => removeRecord(data)}
              disabled={isLoading}
            >
              {isLoading ? "جارٍ المعالجة..." : "الغاء قفل"}
            </button>
          );
        },
      },
    ],
    [loadingStates]
  );

  const exportHeaders = useMemo(
    () => ({
      sectorCode: "رقم القطعة",
      parcelCode: "الحي",
      hodCode: "الحوض",
      vilCode: "القرية",
    }),
    []
  );

  const getLockedAndUnlockedLandData = async () => {
    try {
      handleLoading(loadingDispatch, true);
      const response = await api.get("/lands/print/blocked/list");
      setDataTable(response.data.data.list);
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  };

  const removeRecord = async (record) => {
    try {
      setLoadingStates((prevStates) => ({
        ...prevStates,
        [record.dlsKey]: true,
      }));

      await api.post("/lands/print/prevent", {
        dlsKey: record?.dlsKey,
        lockType: LockTypeEnum.allow,
      });

      setDataTable((prevData) =>
        prevData.filter((item) => item !== record)
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingStates((prevStates) => ({
        ...prevStates,
        [record.dlsKey]: false,
      }));
    }
  };

  useEffect(() => {
    getLockedAndUnlockedLandData();
  }, []);

  const filteredData = useMemo(() => {
    return dataTable.filter((item) => {
      return (
        (watchedData.sectorCode ? item.sectorCode.includes(watchedData.sectorCode) : true) &&
        (watchedData.parcelCode ? item.parcelCode.includes(watchedData.parcelCode) : true) &&
        (watchedData.hodCode ? item.hodCode.includes(watchedData.hodCode) : true) &&
        (watchedData.vilCode ? item.vilCode.includes(watchedData.vilCode) : true)&&
        (watchedData.dlsKey ? item.dlsKey.includes(watchedData.dlsKey) : true)
      );
    });
  }, [dataTable, watchedData]);

  return (
    <>
      <h2 className="content__title title mt-3">أراضي مغلقة ومفتوحة</h2>
      <form className="table__filter">
        <Form.Group className="input input-md">
          <Form.Label>رقم القطعة</Form.Label>
          <Form.Control {...register(`sectorCode`)} />
        </Form.Group>
        <Form.Group className="input input-md">
          <Form.Label>الحي</Form.Label>
          <Form.Control {...register(`parcelCode`)} />
        </Form.Group>
        <Form.Group className="input input-md">
          <Form.Label>الحوض</Form.Label>
          <Form.Control {...register(`hodCode`)} />
        </Form.Group>
        <Form.Group className="input input-md">
          <Form.Label>القرية</Form.Label>
          <Form.Control {...register(`vilCode`)} />
        </Form.Group>
      </form>
      <div>
        <Table
          data={filteredData}
          columns={headers}
          exportHeaders={exportHeaders}
          headerTitle="أراضي مغلقة ومفتوحة"
          exportName="أراضي مغلقة ومفتوحة"
        />
      </div>
    </>
  );
}

export default LockedAndUnlockedLand;
